<script lang="ts" setup>
export interface RichEditorProps {
    data: {
        url: ThumborThumbnail
        media_finder_alt: string
        media_finder_width: number
        media_finder_height: number
        media_finder_url: string
        media_finder_open_in_new_window: string
    }
}
const props = defineProps<RichEditorProps>()
const mediaRef = ref<HTMLElement | null>(null)
const addSpacing = ref<boolean>(false)

onMounted(() => {
    if (mediaRef.value) {
        addSpacing.value = mediaRef.value?.nextElementSibling?.classList.contains('btn') ?? false
    }
})
</script>
<template>
  <div
    ref="mediaRef"
    :class="{ 'mb-5': addSpacing }"
  >
    <Typo>
      <a
        v-if="props.data.media_finder_url"
        :href="props.data.media_finder_url"
        :target="props.data.media_finder_open_in_new_window === '1' ? '_blank' : '_self'"
      >
        <img
          loading="lazy"
          decoding="async"
          class="d-block img-fluid w-100"
          aria-hidden="true"
          :alt="props.data.media_finder_alt || ''"
          :width="props.data.media_finder_width"
          :height="props.data.media_finder_height"
          :src="props.data.url?.['1170x0']?.url"
          :srcset="`${props.data.url?.['2340x0']?.url ?? ''} 2340w, ${props.data.url?.['1170x0']?.url ?? ''} 1170w, ${props.data.url?.['585x0']?.url ?? ''} 585w, ${props.data.url?.['292x0']?.url ?? ''} 292w`"
          sizes="(min-width: 1170px) 117rem, 100vw"
        >
      </a>
    
      <img
        v-else
        loading="lazy"
        decoding="async"
        class="d-block img-fluid w-100"
        aria-hidden="true"
        :alt="props.data.media_finder_alt || ''"
        :width="props.data.media_finder_width"
        :height="props.data.media_finder_height"
        :src="props.data.url?.['1170x0']?.url"
        :srcset="`${props.data.url?.['2340x0']?.url ?? ''} 2340w, ${props.data.url?.['1170x0']?.url ?? ''} 1170w, ${props.data.url?.['585x0']?.url ?? ''} 585w, ${props.data.url?.['292x0']?.url ?? ''} 292w`"
        sizes="(min-width: 1170px) 117rem, 100vw"
      >
    </Typo>
  </div>
</template>
